module.exports = __webpack_public_path__ + "img/Background.6a758765.png";